import { createElementIdSlice } from '../utils/action/createElementSlice';
export const WebContentState = createElementIdSlice({
    elementName: 'web-content',
    initialState: {},
    reducers: {},
});
